import React, { useContext, useState } from "react";
import useProyecto from "../../hooks/useProyecto";
import { ModalContext } from "../../context/ModalContext";
import { getEstadosByPermiso } from "../../utils/estimacionesversiones";
import { CambioOrdenCambiosContext } from "../../context/CambioOrdenCambiosContext";
import { OrdenesCambioContext } from "../../context/OrdenesCambioContext";

const OrdenCambioCierreForm = ({ handleCancel, handleCallback }) => {
  const [comentario, setComentario] = useState("");
  const [estado, setEstado] = useState("");
  const [step, setStep] = useState("");
  const [code, setCode] = useState("");

  const { idProyecto, permiso } = useProyecto();

  const { alert } = useContext(ModalContext);
  const { ordencambio, saveOrdenCambio } = useContext(
    OrdenesCambioContext
  );
  const {
    cambioordencambio,
    setCambioOrdenCambio,
    verifyCambioOrdenCambio,
  } = useContext(CambioOrdenCambiosContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (comentario === "") {
      return alert("Debes incluir un comentario");
    }
    setStep("verification");
    saveOrdenCambio(
      idProyecto,
      { ...ordencambio, estado, comentario },
      handleSubmitCallback
    );
  };

  const handleSubmitCallback = (cambio) => {
    setCambioOrdenCambio(cambio);
  };

  const handleVerification = (e) => {
    e.preventDefault();
    verifyCambioOrdenCambio(
      idProyecto,
      cambioordencambio.idCambioOrdenCambio,
      code,
      handleCallback
    );
  };

  const renderOptions = () => {
    const options = getEstadosByPermiso(permiso, ordencambio.estado);
    return options.map((current) => (
      <option value={current.value} key={current.value}>
        {current.label}
      </option>
    ));
  };

  const renderForm = () => {
    if (step !== "verification")
      return (
        <form onSubmit={handleSubmit}>
          <label>Estado</label>
          <select
            value={estado}
            className="form-control mb-3"
            onChange={(e) => setEstado(e.target.value)}
          >
            {renderOptions()}
          </select>
          <label>Comentario</label>
          <textarea
            rows="3"
            value={comentario}
            className="form-control mb-3"
            onChange={(e) => setComentario(e.target.value)}
          />
          <div className="row">
            <div className="col">
              <button
                type="button"
                onClick={handleCancel}
                className="btn w-100 text-muted"
              >
                Cancelar
              </button>
            </div>
            <div className="col">
              <button type="submit" className="btn w-100 btn-primary">
                Guardar
              </button>
            </div>
          </div>
        </form>
      );
    if (cambioordencambio === null)
      return <div className="spinner-border" />;
    return (
      <form onSubmit={handleVerification}>
        <label>Código de Verificación</label>
        <input
          type="text"
          value={code}
          className="form-control mb-3"
          onChange={(e) => setCode(e.target.value)}
        />
        <div className="row">
          <div className="col">
            <button
              type="button"
              onClick={handleCancel}
              className="btn w-100 text-muted"
            >
              Cancelar
            </button>
          </div>
          <div className="col">
            <button type="submit" className="btn w-100 btn-primary">
              Verificar
            </button>
          </div>
        </div>
      </form>
    );
  };

  return <div>{renderForm()}</div>;
};

export default OrdenCambioCierreForm;
